export const isEqual = (firstItem, secondItem) => {
    // if first and second item is null, undefined, or NaN, return true
    if (!firstItem && !secondItem) {
        return true;
    }

    return firstItem === secondItem;
}